import React, { useEffect, useRef, useState } from "react";
import { CollapsibleWrapper } from "./styled";
import { FaAngleDown } from "react-icons/fa";

const Collapsible = ({
  open,
  children,
  header,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const [height, setHeight] = useState(
    open ? undefined : 0
  );
  const ref = useRef(null);
  const handleFilterOpening = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!height || !isOpen || !ref.current) return undefined;
    const resizeObserver = new ResizeObserver((el) => {
      setHeight(el[0].contentRect.height);
    });

    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [height, isOpen]);

  useEffect(() => {
    if (isOpen) setHeight(ref.current?.getBoundingClientRect().height);
    else setHeight(0);
  }, [isOpen]);

  return (
    <CollapsibleWrapper {...props}>
      <div
        className={`header bt-grey-1 clickable
          } ${isOpen ? "header-active" : ""}`}
        onClick={handleFilterOpening}
      >
        <div>{header}</div>
        <FaAngleDown
          width={24}
          height={24}
          className={`collapsible-arrow ${isOpen ? "is-active" : ""
            } text-black`}
        />
      </div>

      <div className="content" style={{ height }}>
        <div className="content_body px-10 pt-10" ref={ref}>
          {children}
        </div>
      </div>
    </CollapsibleWrapper>
  );
};

export default Collapsible;
